// Default cache keys used for Apollo @client local state caching

export const assetHierarchyFilters = { main: 'assetHierarchyFiltersMain', minor: 'assetHierarchyFiltersMinor' };

export const userGroupsPager = 'userGroupsPager';
export const userGroupsFilter = 'userGroupsFilter';

export const applicationsPager = 'applicationsPager';
export const applicationsFilter = 'applicationsFilter';
